import { useUrlParamEnabled } from "@/react/hooks/utils/useUrlParamEnabled";

export const useIsNewBillingPageEnabled = (): boolean =>
  useUrlParamEnabled("new_billing_page");
